import { getContrastRatio, rgbToHex } from '@epilot/journey-elements'
import type { StepExtended } from '@epilot/journey-logic-commons'

export const getIconColor = ({
  backgroundColor,
  mainColor
}: {
  backgroundColor: string
  mainColor: string
}) => {
  const isBackgroundColorCloseToWhite =
    getContrastRatio(backgroundColor, '#ffffff') < 2

  const isBackgroundColorCloseToMainColor =
    getContrastRatio(backgroundColor, rgbToHex(mainColor).slice(0, 7)) < 2

  if (isBackgroundColorCloseToWhite && isBackgroundColorCloseToMainColor) {
    return 'black'
  }
  if (isBackgroundColorCloseToWhite) {
    return rgbToHex(mainColor).slice(0, 7)
  }

  return 'white'
}

/**
 * this function would clean up the required array from blocks mentioned there that are not referenced in the uischema
 * @param rawStep the step to clean up
 * @returns cleaned step
 */
export function protectAgainstRequiredNoUischema(
  uischema: StepExtended['uischema'],
  blockesRequired?: string[]
) {
  // const step = structuredClone(rawStep)
  // const blockesRequired = step.schema?.required
  let cleanedArray: string[] = []

  if (blockesRequired && blockesRequired.length > 0) {
    const uischemaStr = JSON.stringify(uischema)

    // filter any block which does not exists in uischema
    cleanedArray = blockesRequired.filter((blockName) =>
      uischemaStr.includes(`#/properties/${blockName}`)
    )
  }

  return cleanedArray
}
